import React from "react";
import footerBg from "../../assets/images/backgrounds/footerBg.webp";

const DemoSection = () => {
  return (
    <section className="max-w-5xl mx-auto px-4 text-defaultText">
      {/* Heading */}
      <div className="mb-10">
        <h2 className="text-xl md:text-2xl font-semibold">
          <span className="font-bold">Everything</span> You Need To Know <br />
          About Edupro Hub — <span className="font-bold">In One Demo</span>
        </h2>
        <p className="mt-4 max-w-2xl mx-auto text-base font-outfitRegular">
          In Just <strong>One Call</strong>, You'll Get A Complete Tour Of How{" "}
          <strong>Edupro Hub</strong> Helps Coaching Centers Like Yours Deliver
          Real Exam Experiences And Manage Everything Digitally — All From One
          Powerful Platform.
        </p>
      </div>

      {/* Feature Badges */}
      <div className="flex flex-wrap md:flex-nowrap gap-3 mb-10">
        {[
          "24/7 Support",
          "Proven Results",
          "Pan-India reach",
          "Real Exam Simulations",
        ].map((item, idx) => (
          <span
            key={idx}
            className="px-4 py-2 bg-white rounded-md text-sm text-nowrap shadow-[0px_4px_6px_-1px_rgba(0,0,0,0.1),_0px_-4px_6px_-1px_rgba(0,0,0,0.05)]"
          >
            {item}
          </span>
        ))}
      </div>

      {/* What We'll Cover Box */}
      <div
        className="rounded-xl shadow-sm px-6 py-6  bg-cover bg-center"
        style={{
          backgroundImage: `url(${footerBg})`,
        }}
      >
        <h3 className="md:text-lg font-outfitSemiBold mb-4">
          What We'll Cover{" "}
          <span className="font-outfitLight ">In The Demo :</span>
        </h3>
        <ul className="space-y-4 text-sm">
          <ListItem>
            <strong>Simulating Real Exam Day:</strong>{" "} 
            CBT Interface, Admit
            Cards, ID Checks & Invigilation
          </ListItem>
          <ListItem>
            <strong>Creating Exams With Ease</strong> Using Multiple Question
            Types
          </ListItem>
          <ListItem>
            <strong>
              Managing Your Batches, Fees, Content, Results & More
            </strong>{" "}
            With LMS + ERP
          </ListItem>
          <ListItem>
            <strong>Tracking Student Performance</strong> With Instant Reports &
            Smart Analytics
          </ListItem>
          <ListItem>
            <strong>Your Questions, Answered</strong> — With Practical Examples
            & Use Cases
          </ListItem>
        </ul>
      </div>
    </section>
  );
};

const ListItem = ({ children }) => (
  <li className="flex items-start font-outfitRegular">
    <span className="h-3 w-3 bg-primary-900 mt-1 mr-2 rounded-[2px] rotate-[30deg] shrink-0">

    </span>
    <span>{children}</span>
  </li>
);

export default DemoSection;
